import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useShowAbout = () => {
  const handler = useDispatch();
  return useCallback(({ show }) => handler({ type: actions.SHOW_ABOUT, show }), []);
};

export default {
  useShowAbout,
};
